<template>
  <div class="min-h-screen bg-gray-50">
    <!-- Public Header -->
    <header class="bg-white shadow-sm">
      <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div class="flex h-16 justify-between items-center">
          <!-- Logo -->
          <div class="flex items-center">
            <router-link to="/" class="flex items-center space-x-2">
              <div class="w-8 h-8 flex items-center justify-center">
                <SharedIcon :size="32" gradient-id="gradient-public" />
              </div>
              <span class="text-xl font-bold text-gray-900">ASAB</span>
            </router-link>
          </div>

          <!-- Navigation -->
          <nav class="hidden md:flex space-x-8">
            <router-link
              to="/"
              class="text-gray-500 hover:text-gray-900 px-3 py-2 text-sm font-medium"
            >
              Home
            </router-link>
            <router-link
              to="/auth/login"
              class="text-gray-500 hover:text-gray-900 px-3 py-2 text-sm font-medium"
            >
              Sign In
            </router-link>
            <router-link
              to="/auth/register"
              class="bg-blue-600 text-white hover:bg-blue-700 px-4 py-2 text-sm font-medium rounded-md"
            >
              Get Started
            </router-link>
          </nav>

          <!-- Mobile menu button -->
          <div class="md:hidden">
            <button
              type="button"
              class="text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500 p-2 rounded-md"
              @click="mobileMenuOpen = !mobileMenuOpen"
            >
              <span class="sr-only">Open main menu</span>
              <!-- Menu icon -->
              <svg
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
                />
              </svg>
            </button>
          </div>
        </div>

        <!-- Mobile menu -->
        <div v-if="mobileMenuOpen" class="md:hidden">
          <div class="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            <router-link
              to="/"
              class="text-gray-500 hover:text-gray-900 block px-3 py-2 text-base font-medium"
              @click="mobileMenuOpen = false"
            >
              Home
            </router-link>
            <router-link
              to="/auth/login"
              class="text-gray-500 hover:text-gray-900 block px-3 py-2 text-base font-medium"
              @click="mobileMenuOpen = false"
            >
              Sign In
            </router-link>
            <router-link
              to="/auth/register"
              class="bg-blue-600 text-white hover:bg-blue-700 block px-3 py-2 text-base font-medium rounded-md"
              @click="mobileMenuOpen = false"
            >
              Get Started
            </router-link>
          </div>
        </div>
      </div>
    </header>

    <!-- Main content -->
    <main>
      <router-view />
    </main>

    <!-- Footer -->
    <footer class="bg-white border-t">
      <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div class="py-8">
          <div class="text-center text-sm text-gray-500">© 2026 ASAB. All rights reserved.</div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script setup lang="ts">
  import { ref } from 'vue';
  import { SharedIcon } from '@asabdev/asab-ui';

  const mobileMenuOpen = ref(false);
</script>
